import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import ProductCard from "web/react/components/product-card/product-card";
import analytics from "web/script/analytics/analytics";
import { ProductCardType } from "web/types/product-card";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import styles from "./top-products.css";

export interface TopProductsProps {
    products: ProductCardType[];
}

export function TopProducts({ products }: TopProductsProps): JSX.Element {
    const id = "top-50-products";

    function handleDrag(): void {
        analytics.event("rail", "drag", "homepage-top-products");
    }

    return (
        <DragRail id={id} onDragStart={handleDrag} className={styles.wrapper}>
            <div className={styles.productsContainer}>
                <h2 className={classnames(styles.productCard, styles.titleCard)}>
                    <span className={styles.titleCardText}>
                        {gettext("homepage.module_the_lyst_50.title")}
                    </span>
                </h2>
                {products.map((product) => {
                    return (
                        <ProductCard
                            className={styles.productCard}
                            key={product.id}
                            product={product}
                            imageSize={"feed"}
                            scrollParentId={id}
                        />
                    );
                })}
            </div>
        </DragRail>
    );
}

export default TopProducts;
